import styled from 'styled-components'

export const EditProgramContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const EditProgramCalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const EditProgramHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px
`

export const EditProgramTitle = styled.h6`
  margin: 0;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
  line-height: 26px;
`
export const EditProgramButtonContainer = styled.div`
  margin-top: 50px;
  margin-left: 28%;
`

export const LeftProgramButtonContainer = styled.div`
  position: absolute;
  right: 100px;
`

export const RightProgramButtonContainer= styled.div`
position: absolute;
left: 100px;
`

export const CalendarContainer = styled.div`
  margin-top: 90px;
`

export const SubmitProgramButtonContainer = styled.div`
  margin-top: 50px;
  margin-left: 40%;
`

export const EditProgramCourtContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 35px;
`
export const EditProgramCheckBoxRow = styled.div`
  display: flex;  
  justify-content: space-between;
  margin-top: 25px;
`
export const EditProgramDateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 48px;
`

export const EditProgramCheckboxContainer = styled.div`
  display: inline-grid;
  margin-right: 40px;`

export const EditProgramCourtCheckTitle = styled.p`
  padding: 0px 14px;
  left: 8px;
  font-weight: 600;
  font-size: 13px;
`
export const EditProgramCourtCheckTitleM = styled.span`
  color: #F45353;
`
